import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ProfileProvider } from './contexts/ProfileContext';
import { QuestionsProvider } from './contexts/QuestionsContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import CareerComparison from './pages/CareerComparison';
import Mentorship from './pages/Mentorship';
import Scholarships from './pages/Scholarships';
import SkillDevelopment from './pages/SkillDevelopment';
import CareerSimulator from './pages/CareerSimulator';
import MarketTrends from './pages/MarketTrends';
import Internships from './pages/Internships';
import About from './pages/About';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import HelpCenter from './pages/HelpCenter';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import FAQ from './pages/FAQ';
import NotFound from './pages/NotFound';
import Footer from './components/Footer';

function App() {
  return (
    <AuthProvider>
      <QuestionsProvider>
        <ProfileProvider>
          <Router>
            <div className="min-h-screen flex flex-col">
              <Header />
              <main className="flex-grow bg-gray-50">
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/dashboard/:careerPathId" element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  } />
                  <Route path="/profile" element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  } />
                  <Route path="/settings" element={
                    <ProtectedRoute>
                      <Settings />
                    </ProtectedRoute>
                  } />
                  <Route path="/compare" element={
                    <ProtectedRoute>
                      <CareerComparison />
                    </ProtectedRoute>
                  } />
                  <Route path="/skills" element={
                    <ProtectedRoute>
                      <SkillDevelopment />
                    </ProtectedRoute>
                  } />
                  <Route path="/career-simulator" element={
                    <ProtectedRoute>
                      <CareerSimulator />
                    </ProtectedRoute>
                  } />
                  <Route path="/mentorship" element={
                    <ProtectedRoute>
                      <Mentorship />
                    </ProtectedRoute>
                  } />
                  <Route path="/internships" element={
                    <ProtectedRoute>
                      <Internships />
                    </ProtectedRoute>
                  } />
                  <Route path="/scholarships" element={
                    <ProtectedRoute>
                      <Scholarships />
                    </ProtectedRoute>
                  } />
                  <Route path="/market-trends" element={
                    <ProtectedRoute>
                      <MarketTrends />
                    </ProtectedRoute>
                  } />
                  <Route path="/about" element={<About />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/help" element={<HelpCenter />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
              <Toaster 
                position="top-center"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                }}
              />
            </div>
          </Router>
        </ProfileProvider>
      </QuestionsProvider>
    </AuthProvider>
  );
}

export default App;